import {Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, ChangeDetectorRef} from '@angular/core';
import {UsersService} from 'projects/app-misc/src/app/modules/users/data/users.service';
import {ProjectActivityService} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {LocalStorageService} from 'ngx-webstorage';
import {User} from 'projects/core/src/lib/login/data/user';
import {ActivityType} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/activity-type';
import {DeviceDetectorService} from 'ngx-device-detector';

interface UserOption {
  id: number;
  name: string;
}

@Component({
  selector: 'app-users-filter',
  templateUrl: './users-filter.component.html',
  styleUrls: ['./users-filter.component.scss']
})
export class UsersFilterComponent implements OnInit, OnChanges {

  @Input() selectedTypeIds: number[] = [];
  @Input() storageKey = 'fc_users_filter_selectedUserIds';
  @Output() filterChange = new EventEmitter<number[]>();

  users: User[] = [];
  userOptions: UserOption[] = [];
  types: ActivityType[] = [];
  previousUserOptions: UserOption[] = [];
  selectedItemsLabel = 'Select Users';

  selectedUserIds?: number[];
  isMobile = false;

  constructor(
    protected usersService: UsersService,
    protected projectActivityService: ProjectActivityService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private localStorageService: LocalStorageService
  ) {
  }

  loadStoredUserIds(): number[] | null {
    return this.localStorageService.retrieve(this.storageKey);
  }

  saveUserIds(ids: number[]) {
    this.localStorageService.store(this.storageKey, ids);
  }

  ngOnInit() {
    const stored = this.loadStoredUserIds();
    this.selectedUserIds = (stored !== null && stored !== undefined) ? stored : [];
    this.projectActivityService.getActivityTypes()
      .subscribe(types => {
        this.types = types;
        this.getUsers();
      });
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedTypeIds && this.selectedTypeIds && this.selectedTypeIds.length > 0 && this.types.length > 0) {
      this.getUsers();
    }
  }

  getUsers() {
    const typeNames = this.selectedTypeIds
      .map(id => this.types.find(t => t.id === id))
      .filter(t => t !== undefined)
      .map(t => t.name)
      .join(',');

    if (!typeNames) return;

    this.usersService.getUsersByActivityTypes(typeNames)
      .subscribe(users => {
        this.users = users;
        this.userOptions = [{id: -1, name: 'No User'}, ...users.map(u => ({
          id: u.id, name: u.firstName + ' ' + u.lastName.substr(0, 1) + '.'
        }))];

        let validUserIds = this.userOptions.map(u => u.id);
        if (validUserIds == null) validUserIds = [];
        const previousValidUserIds = this.previousUserOptions.map(u => u.id);
        const hadAllSelected = this.previousUserOptions.length > 0 &&
                                this.selectedUserIds &&
                                this.selectedUserIds.length === previousValidUserIds.length;

        if (typeof this.selectedUserIds === 'undefined' || this.selectedUserIds === null) {
          this.selectedUserIds = validUserIds;
        } else if (hadAllSelected) {
          this.selectedUserIds = validUserIds;
        } else {
          this.selectedUserIds = this.selectedUserIds.filter(id => validUserIds.includes(id));

          if (this.selectedUserIds.length === 0) {
            this.selectedUserIds = validUserIds;
          }
        }

        this.previousUserOptions = [...this.userOptions];
        this.saveUserIds(this.selectedUserIds);
        this.updateLabel();
        this.filterChange.emit(this.selectedUserIds);
      });
  }

  onFilterChange() {
    this.saveUserIds(this.selectedUserIds);
    this.updateLabel();
    this.cdr.detectChanges();
    this.filterChange.emit(this.selectedUserIds);
  }

  updateLabel() {
    if (!this.selectedUserIds || this.selectedUserIds.length === 0) {
      this.selectedItemsLabel = 'Select Users';
      return;
    }
    const hasNoUser = this.selectedUserIds.findIndex(u => u === -1) !== -1;
    if (this.selectedUserIds.length === (this.users.length + 1)) {
      this.selectedItemsLabel = 'All Users, No User';
    } else {
      if (!hasNoUser && this.selectedUserIds.length >= this.users.length) {
        this.selectedItemsLabel = 'All Users';
      } else if (hasNoUser) {
        this.selectedItemsLabel = (this.selectedUserIds.length - 1) + ' Users, No User';
      } else {
        this.selectedItemsLabel = this.selectedUserIds.length + ' Users';
      }
    }
  }
}
